import { useEffect, useState } from "react";

/** Tailwind `xl` breakpoint (px). Keep in sync with `xl:*` utilities. */
export const XL_MIN_WIDTH_PX = 1280;

function isXlViewport(): boolean {
  return window.innerWidth >= XL_MIN_WIDTH_PX;
}

/**
 * Tracks whether the viewport is at least the Tailwind `xl` breakpoint
 * (1280px). Mirrors the `isLgViewport` pattern in app-shell.tsx: a direct
 * `window.innerWidth` read plus a resize listener. Used to decide whether the
 * right-side panels render as a persistent dock (`>= xl`) or as lightbox
 * sheets (`< xl`).
 */
export function useIsXlViewport(): boolean {
  const [isXl, setIsXl] = useState<boolean>(() => isXlViewport());
  useEffect(() => {
    const onResize = (): void => setIsXl(isXlViewport());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isXl;
}
